import { render, staticRenderFns } from "./findschool.vue?vue&type=template&id=2340abd5&scoped=true"
import script from "./findschool.vue?vue&type=script&lang=js"
export * from "./findschool.vue?vue&type=script&lang=js"
import style0 from "./findschool.vue?vue&type=style&index=0&id=2340abd5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2340abd5",
  null
  
)

export default component.exports